<template>
  <section class="section section--gray pb-60 pt-60 mb-0">
    <div class="container">
      <h3 class="section__title">Наши клиенты</h3>
      <div class="row">
        <div class="col-m-3 col-s-3 col-x-6" v-for="client in clients">
          <a :href="client.href" class="logo-link" target="_blank" :title="client.name">
            <img :src="client.img" />
          </a>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
const name = 'Clients'

function data() {
  return {
    clients: [{
      name: 'Мвидео',
      img: require('@/assets/img/clients/mvideo.svg'),
      href: 'https://mvideo.ru'
    }, {
      name: 'РЖД',
      img: require('@/assets/img/clients/rzhd.svg'),
      href: 'https://www.rzd.ru/'
    }, {
      name: 'Инвитро',
      img: require('@/assets/img/clients/invitro.svg'),
      href: 'https://www.invitro.ru/'
    }, {
      name: 'Jameson',
      img: require('@/assets/img/clients/jameson.svg'),
      href: 'https://www.jamesonwhiskey.com/'
    }, {
      name: 'CarementorAI',
      img: require('@/assets/img/clients/carementor.svg'),
      href: 'https://carementor.ru/'
    }, {
      name: 'GoodWood',
      img: require('@/assets/img/clients/gwd.svg'),
      href: 'https://gwd.ru'
    }, {
      name: 'Стадион Калининград',
      img: require('@/assets/img/clients/stadium.svg'),
      href: 'https://www.stadiumkgd.ru/'
    }, {
      name: 'Digital Adversary',
      img: require('@/assets/img/clients/da.png'),
      href: 'https://digitaladversary.com/'
    }]
  }
}

export default {
  name,
  data
}

</script>
